import React from 'react';
import styles from './ClientInfoView.module.scss';
import MapComponent from '../../../../../common/components/organisme/MapComponent/MapComponent';
import { InstallationCodeMiniPresenter } from '../../../../../common/components/atom/InstallationCodeMini';

interface ClientInfo {
  firstName?: string;
  lastName?: string;
  location?: string;
  accountId?: string;
  phone?: string;
  email?: string;
  address?: string;
  latitude?: number;
  longitude?: number;
}

interface ClientInfoViewProps {
  clientInfo: ClientInfo;
  // Compteur affiché : son code d'installation est lu depuis son site.
  deviceId?: string;
  isLoading?: boolean;
  isError?: boolean;
  error?: any;
}

export default function ClientInfoView({
  clientInfo,
  deviceId,
  isLoading, 
  isError, 
  error 
}: ClientInfoViewProps) {
  if (isLoading) {
    return (
      <div className={styles.clientInfoContainer}>
        <div className={styles.loading}>Chargement des informations client...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={styles.clientInfoContainer}>
        <div className={styles.error}>
          Erreur lors du chargement des informations client: {error?.message}
        </div>
      </div>
    );
  }


  return (
    <div className={styles.clientInfoContainer}>
      <div className={styles.clientInfoCard}>
        <div className={styles.content}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Prénom, Nom</span>
            <span className={styles.infoValue}>{clientInfo.firstName} {clientInfo.lastName}</span>
          </div>
          
          {clientInfo.address && (
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>Adresse</span>
              <span className={styles.infoValue}>{clientInfo.address}</span>
            </div>
          )}
          
          {clientInfo.location && (
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>Localisation</span>
              <span className={styles.infoValue}>{clientInfo.location}</span>
            </div>
          )}
          
          {deviceId && (
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>Code installation</span>
              <span className={styles.infoValue}>
                <InstallationCodeMiniPresenter deviceId={deviceId} emptyLabel="Non relié" />
              </span>
            </div>
          )}

          {clientInfo.phone && (
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>Téléphone</span>
              <span className={styles.infoValue}>{clientInfo.phone}</span>
            </div>
          )}
          
          {clientInfo.email && (
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>Email</span>
              <span className={styles.infoValue}>{clientInfo.email}</span>
            </div>
          )}
          
          {clientInfo.accountId && (
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>ID Compte</span>
              <span className={styles.infoValue}>{clientInfo.accountId}</span>
            </div>
          )}
          
          {(clientInfo.latitude !== undefined && clientInfo.latitude !== null && 
            clientInfo.longitude !== undefined && clientInfo.longitude !== null)  && (
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>Coordonnées</span>
              <span className={styles.infoValue}>
                {clientInfo.latitude.toFixed(6)}, {clientInfo.longitude.toFixed(6)}
              </span>
            </div>
          )}
        </div>
        
        {(clientInfo.latitude !== undefined && clientInfo.latitude !== null && 
          clientInfo.longitude !== undefined && clientInfo.longitude !== null) && 
         (clientInfo.latitude !== 0 && clientInfo.longitude !== 0) && (
          <div className={styles.mapSection}>
            <div className={styles.mapLabel}>Localisation sur la carte</div>
            <div className={styles.mapContainer}>
              <MapComponent 
                center={[clientInfo.latitude, clientInfo.longitude]}
                zoom={13}
                pinList={[{
                  position: [clientInfo.latitude, clientInfo.longitude], 
                  name: clientInfo.firstName && clientInfo.lastName 
                    ? `${clientInfo.firstName} ${clientInfo.lastName}` 
                    : clientInfo.location || 'Client'
                }]}
                style={{ height: '100%', width: '100%', borderRadius: '12px' }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
